import axios, { useAxios, useLazyAxios } from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const setSpeakerAssignment = ({ cisId, creatorId }) => {
  return axios.post(`${serviceBaseUrl}/speakers/${cisId}/assignments/${creatorId}`)
}

export const getSpeakerAssignment = (creatorId) => {
  return axios.get(`${serviceBaseUrl}/speakers/assignments/${creatorId}`)
}
export const useSpeakerAssignment = (creatorId) => {
  return useAxios(`${serviceBaseUrl}/speakers/assignments/${creatorId}`)
}
export const useLazySpeakerAssignment = (creatorId) => {
  return useLazyAxios(`${serviceBaseUrl}/speakers/assignments/${creatorId}`)
}

export const deleteSpeakerAssignment = (creatorId) => {
  return axios.delete(`${serviceBaseUrl}/speakers/assignments/${creatorId}`)
}
